import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Department } from '../../shared/models/department.model';

import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})

export class DepartmentService {
	private apiUrl = environment.apiUrl;
	private apiUrl1 = environment.apiUrl1;


	constructor(private http: HttpClient) { }

	getAll() {
		return this.http.get(`${this.apiUrl1}/api/departments`);
	}

	getById(id: number) {
		return this.http.get(`${this.apiUrl1}/api/departments/${id}`);
	}

	create(department) {
		return this.http.post(`${this.apiUrl1}/api/departments`, department);
	}

	update(department) {
		return this.http.put(`${this.apiUrl1}/api/departments/${department.id}`, department);
	}

	delete(id: number) {
		return this.http.delete(`${this.apiUrl1}/api/departments/${id}`);
	}

	deleteDepartmentRole(id: number, roleId: number) {
		return this.http.delete(`${this.apiUrl}/api/departments/${id}/${roleId}`);
	}

	getDepartmentDetail(departmentId: number, roleId: number) {
		return this.http.get(`${this.apiUrl1}/api/departments/${departmentId}/${roleId}`);
	}

	updateDepartmentDetail(departmentId: number, roleId: number, menu: {}) {
		return this.http.put(`${this.apiUrl1}/api/departments/${departmentId}/${roleId}`, menu);
	}

	getDepartmentsClientsRoles() {
		return this.http.get(`${this.apiUrl}/api/departments/clients-roles`);
	}
}
